<template>
  <div class="relative">
    <div v-if="!prefilledEducationComplete || !prefilledCareerPassportComplete"
         class="mx-auto grid max-w-3xl grid-cols-1 gap-4"
         :class="!prefilledEducationComplete && !prefilledCareerPassportComplete && 'md:grid-cols-2'">
      <div v-if="!prefilledCareerPassportComplete" class="col-span-1 max-w-3xl">
        <FormLabel label="Add Your Work History" :label-hint="historyBypassed ? '' : '(1 Entry Required)'"/>
        <div v-if="historyBypassed" class="my-4">
          <p class="text-slate-600">No previous work experience</p>
          <button type="button" data-test="add-work-history"
                  class="mt-2 text-primary-600 underline hover:no-underline"
                  @click="store.state.noPreviousWorkExperience = false">
            Add work history instead
          </button>
        </div>
        <FormButton v-else-if="canBypassHistory" color="secondary" size="full" medium data-test="skip-work-history"
                class="my-4 px-4 text-center"
                @click="bypassHistory">
          No previous work experience? Skip this section
        </FormButton>
        <AnswerItemList v-if="!historyBypassed"
                        :question="candidateCareerPassport.passport"
                        :use-store="useStore"/>
      </div>
      <div v-if="!prefilledEducationComplete" class="col-span-1 max-w-3xl">
        <FormLabel label="Add Your Education" label-hint="(1 Entry Required)"/>
        <AnswerItemList :question="candidateEducationBadges.education"
                        :use-store="useStore"/>
      </div>
    </div>
    <div v-if="!prefilledExceptionalAbilityComplete" class="mx-auto mt-8 mb-12 max-w-3xl">
      <FormLabel label="Your 3 Exceptional Abilities" label-hint="(Required)"/>
      <div class="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <FormInput v-for="(num) in 3"
                   :key="num"
                   :label="`Ability #${num}`"
                   :placeholder="`Ability #${num}`"
                   v-model="store.state.exceptionalAbility[num - 1]"
                   class="col-span-1"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {candidateCareerPassport, candidateEducationBadges} from "../helpers/ProfileQuestions.js";
import FormLabel from "./FormLabel.vue";
import FormInput from "./FormInput.vue";
import FormButton from "./FormButton.vue";
import AnswerItemList from "./AnswerItemList.vue";
import {computed} from "vue";

const props = defineProps({
  prefilledEducationComplete: Boolean,
  prefilledCareerPassportComplete: Boolean,
  prefilledExceptionalAbilityComplete: Boolean,
  useStore: Function,
  useTwoColumns: Boolean,
});

const store = props.useStore();

const historyBypassed = computed(() => store.state.noPreviousWorkExperience === true && !store.state.careerPassport?.length);
// The editor initializes a blank row. Only untouched rows can be removed by this shortcut.
const canBypassHistory = computed(() => !(store.state.careerPassport || []).some((entry) =>
  Object.values(entry).some((value) => value !== null && value !== undefined && value !== "" && value !== 0 && value !== false)
));

const bypassHistory = () => {
  if (!canBypassHistory.value) return;
  store.state.careerPassport = [];
  store.state.noPreviousWorkExperience = true;
};
</script>
